import React from "react"

const HeroText = ({ text }) => <p className="text-lg mb-4">{text}</p>

export default HeroText
